import { documentsEndpoints } from '../../../api/generated/cz.partners.bank.backofficegateway.documents/wrappers';

type UseAvailableDocumentsParams = {
	clientPidUuid: string;
};

export const useAvailableDocuments = ({
	clientPidUuid,
}: UseAvailableDocumentsParams) => {
	const availableDocumentsQuery =
		documentsEndpoints.getAvailableDocumentsV5.useQuery({
			clientPidUuid,
		});

	const bankDocumentTemplates =
		availableDocumentsQuery.data?.data.bankDocumentTemplates;
	const clientDocumentTemplates =
		availableDocumentsQuery.data?.data.clientDocumentTemplates;
	const isLoading = availableDocumentsQuery.isPending;

	return {
		bankDocumentTemplates,
		clientDocumentTemplates,
		isLoading,
	};
};
